import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonNormalSmall } from "../generic/common/ButtonNormalSmall";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
var _HudBottomRightOptions = function (_a) {
    var onMenuOpen = _a.onMenuOpen;
    return (React.createElement("div", null,
        React.createElement(TooltipText, { id: IdLoca.settingsMenu_category1, anchor: IdTooltipAnchor.BottomRight },
            React.createElement(ButtonNormalSmall, { onClick: function () { return onMenuOpen(IdModal.Settings); } },
                React.createElement("div", { className: "flex flex--guts w100 h100" },
                    React.createElement(Icon, { icon: IdIcon.SettingsIcn, styleId: IdStyles.IconLarge }))))));
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onMenuOpen: actionModalOpen,
    }, dispatch);
};
export var HudBottomRightOptions = connect(undefined, mapDispatch)(_HudBottomRightOptions);



//////////////////
// WEBPACK FOOTER
// ./src/features/options/HudBottomRightOptions.tsx
// module id = 2275
// module chunks = 3